import React from "react"
import { Link } from "react-scroll"

const data = [
  {
    id: 1,
    text: "home",
    url: "hero",
  },
  {
    id: 2,
    text: "about",
    url: "about",
  },
  {
    id: 3,
    text: "projects",
    url: "projects",
  },
  {
    id: 4,
    text: "contact",
    url: "contact",
  },
]

export default ({ styleClass , toggleSidebar}) => {
  return (
    <ul className={`${styleClass ? styleClass : ""}`}>
      {data.map(link => (
          <li key={link.id}>
            <Link to={link.url} smooth={!toggleSidebar} duration={1000} offset={-80} onClick={toggleSidebar}>{link.text}</Link>
          </li>
        )
      )}
    </ul>
  )
}
